import { HandlerBase } from "../handler/abstract/handler-base";

export class PageConfig {

    /**
     * @param handler {HandlerBase}
     * @param internalCode {string}
     * */
    constructor(handler, internalCode) {

        /** @type {HandlerBase}*/
        this.handler = handler;
        this.internalCode = internalCode
    }

}
